import React, { FC } from 'react';
import { Box, ListGroup } from '@cubeyou-team/hx-react-components';

import { StanleyQueryHistoryListItem } from 'src/modules/query-builder/components/stanley-query/api/types';
import { useStanleyQueryPanel } from '../../../../providers/StanleyQueryPanelContext';
import { StanleyQueryHistoryListRow } from './components';

interface StanleyQueryHistoryItemProps {
  data: StanleyQueryHistoryListItem[];
}

export const StanleyQueryHistoryItem: FC<StanleyQueryHistoryItemProps> = ({
  data,
}) => {
  const { handleSelectHistoryItem } = useStanleyQueryPanel();

  return (
    <Box>
      <ListGroup
        items={data.map(({ run_id, title }) => (
          <StanleyQueryHistoryListRow
            key={run_id}
            runId={run_id}
            title={title}
            onSelect={handleSelectHistoryItem}
          />
        ))}
      />
    </Box>
  );
};
